<template>
  <a
    class="to-top"
    v-show="show"
    @click="toTop()">
    <SvgIcon 
      icon-class="to-top"/>
    <span>顶部</span>
  </a>
</template>

<script>
const position = 100
export default {
  data () {
    return {
      show: false
    }
  },
  methods: {
    toTop(){
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    scroll(){
      let sTop = document.documentElement.scrollTop || 
        document.body.scrollTop
      if(sTop > position && !this.show)
        this.show = true
      else if(sTop < position && this.show)
        this.show = false
    }
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.scroll)
  },
  mounted(){
    window.addEventListener('scroll', this.scroll)
    this.scroll()
  }
}
</script>

<style lang="scss" scoped>
.to-top{
  position: fixed;
  left: .5rem;
  bottom: 6rem;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 100%;
  background-color: #fff;
  box-shadow: 0 0 2px rgba(0,0,0,.3);
  color: $text1;
  user-select: none;
  cursor: pointer;
  svg{
    font-size: 1.4rem;
  }
  span{
    font-size: 1.15rem;
    transform: scale(.8);
  }
  &:hover{
    box-shadow: 0 0 4px rgba(0,0,0,.3);
    color: $theme-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/ToTop.vue